import { z } from 'zod'

import { UserRole } from './role'

export const salutations = ['mr', 'ms', 'non-binary'] as const

export type Salutation = (typeof salutations)[number]

export const isValidSalutation = (salutation: string): salutation is Salutation =>
  salutations.some((item) => item === salutation)

export const languages = ['en', 'de', 'zh', 'es', 'pl'] as const

export type Language = (typeof languages)[number]

export type User = {
  id: string
  salutation?: Salutation
  firstName: string
  lastName: string
  email: string
  phoneMobile?: string
  phoneLandline?: string
  customerId: string
  roles: UserRole[]
  languages?: Language[]
  organizationId: string
  preferredLanguage?: Language
  title?: string
  registeredAt?: string
  auth0Sub?: string
}

export const maxPasswordLength = 50

export const InviteeDataSchema = z.object({
  email: z.string().email(),
})

export type InviteeData = z.infer<typeof InviteeDataSchema>
